import React, { useState, useEffect } from "react";
import YouTubeVideo from './youtube_video'
import { useInView } from 'react-intersection-observer';

const ThumbNail = ({ eventItem }) => {
  const { ref, inView } = useInView();
  const [showYouTube, setShowYouTube] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowYouTube(inView);
    }, 1000);
  }, [inView]);

  return (
    <div ref={ref}>
      {eventItem.youtube_key && eventItem.youtube_key.length > 0 ? (
        showYouTube ? (
          <YouTubeVideo
            id={eventItem.youtube_key}
            uniqId={eventItem.ad_type ? (eventItem.hashed_event_pr_allocation_id || eventItem.hashed_circles_ad_id) : eventItem.id}
            style={{
              borderRadius: '4.7px 4.7px 0 0',
              border: 'none',
              height: '100%',
              width: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
        ) : (
          <img
            data-src={eventItem.main_image_url_medium}
            alt={eventItem.title}
            className="lazyload w-100 object-fit-contain adjust-box-inner bg-graydark3"
            onError={(e) => {
              e.target.src = "/images/ja2/img_noimage.gif";
            }}
            src={eventItem.main_image_url_medium}
          />
        )
        ) : (
          <img
          data-src={eventItem.main_image_url_medium}
          alt={eventItem.title}
          className="lazyload w-100 object-fit-contain adjust-box-inner bg-graydark3"
          onError={(e) => {
            e.target.src = "/images/ja2/img_noimage.gif";
          }}
          src={eventItem.main_image_url_medium}
        />
      )}
    </div>
  );
};

export default ThumbNail;
